import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';

import { AmplifyService }  from '@flowaccount/aws-amplify-angular';

const aws_exports = require('../aws-exports').default;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'amplify-ng-app';
  signedIn = false;
  user = null;
  files = {};
  dir: string = null;

  constructor(location: Location,
              private amplifyService: AmplifyService) {

    let httpParams = new HttpParams({fromString: location.path().split('?')[1]})

    if(httpParams.has('dir')){
      this.dir = httpParams.get('dir')
    }

    this.amplifyService.authStateChange$
        .subscribe(authState => {
          this.signedIn = authState.state === 'signedIn';

          if (!authState.user) {
            this.user = null;
          } else {
            this.user = authState.user;
            this.get_files(); 
          }
        });
  }

  get_files() {
    if(!this.dir) {
      console.log('dir query parameter not found, no files to list')
      return
    }

    this.amplifyService.storage().configure( {level:'private'} );

    // A user specific folder is needed inside the private folder. This folder name must
    // contain the user cognito id. Attempting to create a file seems to be the only way to
    // find that id. Uncomment this line in dev to find the required folder name. 
    // this.amplifyService.storage().put('test.txt', 'Private Content', {level:'private', contentType: 'text/plain'})

    this.amplifyService.storage().list(this.dir).then((fileArray: any[]) => {

      fileArray.forEach((fileData: any) => {
        if(fileData.size > 0) {
          console.log(fileData)
          fileData.humanSize = this.humanFileSize(fileData.size)
          this.files[fileData.key] = [fileData]
          this.get_file(fileData)
        }
      });
    });
  }

  get_file(fileData: {size: number; key: any;}) {
    this.amplifyService.storage().get(fileData.key).then((fileUrl: any) => {
      this.files[fileData.key].push(fileUrl);
    })
  }

  humanFileSize(size: number) {
    let i = Math.floor( Math.log(size) / Math.log(1024) )
    return (Number((size / Math.pow(1024, i)).toFixed(2)) * 1) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
  }
}